


import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import COdd from '@/components/COdds/COdd.vue'
import { IOdd } from '@/interfaces/sportevents'
const componentName: string = 'COdds'
@Component({
  name: `${componentName}`,
  components: { COdd }
})
export default class UiComponent extends Mixins() {
  @Prop({ default: [] }) public odds!: IOdd[]
}
Vue.component(componentName, UiComponent)
